var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emb"},[(_vm.label)?_c('div',{staticClass:"lb",style:(_vm.stilol)},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('input',_vm._b({class:_vm.label?'tx':'tx_sinlabel',style:(_vm.stilot),on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }